import React from 'react'

// CardCurrencyBrandLegendACDC returns an unordered list of footnotes in HTML format for the ACDC card brand currency table.
// These footnotes should match up with footnotes declared by objects processed by the CodeCurrencyFormat or CurrenciesCell objects.
// If your content won't include one of these footnotes, comment out the line item.
// When your content includes a footnote that isn't defined, add a definition in the unordered list. Follow the same syntax as the other footnotes.
// You can find a full list of footnotes in CardCurrencyBrandLegend.
// CardCurrencyBrandLegendACDC takes no input.

const CardCurrencyBrandLegendACDC = () => {
  return (
    <>
      <ul>
        <li>
          <strong>0</strong> indicates a 0-digit denomination currency.
        </li>
      </ul>
    </>
  )
}

export default CardCurrencyBrandLegendACDC
